import Box from '@mui/material/Box'
import styled from '@emotion/styled'

export const Dashed = styled(Box)`
  ${({ theme }) => `
    border-top: 1px dashed ${theme.palette.background.line};
  `}
`

export const Solid = styled(Box)`
  ${({ theme }) => `
    border-top: 1px solid ${theme.palette.background.line};
  `}
`
